import React from "react";
import type { ItemType } from "@shared/graphql.types";
import { useIsFreeTrial } from "hooks";
import { colours } from "@shared/ui.design-system";
import { Description } from "../Description";

type Props = {
  item: ItemType;
};

export const MembershipDescription: React.FC<Props> = ({ item }) => {
  const isFreeTrial = useIsFreeTrial(item.membership?.id);

  let description =
    {
      annually: "Annual Membership",
      monthly: "Monthly Membership",
      none: ""
    }[item?.membership?.duration ?? ""] || "";

  if (isFreeTrial) {
    description = "";
  }

  return (
    <Description
      titleColor={colours.primary.dark}
      brandName={item?.membership?.name ?? ""}
      subTitle={description ?? ""}
      descriptionVariant="acuminLight"
    />
  );
};
